export default __webpack_public_path__ + "static/media/raffle.da8a76b8.svg";